import React, { useContext, useEffect, useState } from 'react';
import $ from 'jquery';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  TextField
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { parsePhone } from '../../../../helpers/parseValues';
import { useModal } from '../../../../hooks/Modal';
import { DefaultCollectContext } from '../..';
import { ModalTitle } from './styled';

export const ModalReceiveCollectInfo = () => {
  const [temporaryReceiveChecked, setTemporaryReceiveChecked] = useState([
    false,
    false,
    true
  ]);
  const [temporaryPhone, setTemporaryPhone] = useState('');
  const [temporaryPhoneConfirmation, setTemporaryPhoneConfirmation] =
    useState('');
  const [temporaryEmail, setTemporaryEmail] = useState('');
  const [temporaryEmailConfirmation, setTemporaryEmailConfirmation] =
    useState('');

  const { closeModal, Modal } = useModal();

  const maxSM = useMediaQuery('(max-width:768px)');
  const maxMD = useMediaQuery('(max-width:900px)');

  const {
    receiveCollectInfoChecked,
    setReceiveCollectInfoChecked,
    receiveCollectInfoPhone,
    setReceiveCollectInfoPhone,
    receiveCollectInfoEmail,
    setReceiveCollectInfoEmail
  } = useContext(DefaultCollectContext);

  const receiveCollectInfoSchema = Yup.object().shape({
    whatsapp: Yup.boolean(),
    sms: Yup.boolean(),
    email: Yup.boolean(),
    receiveCollectInfoPhone: Yup.string().when(['whatsapp', 'sms'], {
      is: (whatsapp, sms) => !!whatsapp || !!sms,
      then: Yup.string()
        .required('Telefone obrigatório')
        .test('validatePhoneNumber', 'Telefone inválido', (value) => {
          return parsePhone(value).length >= 10;
        })
    }),
    receiveCollectInfoPhoneConfirmation: Yup.string().when(
      ['whatsapp', 'sms'],
      {
        is: (whatsapp, sms) => !!whatsapp || !!sms,
        then: Yup.string()
          .required('Telefone obrigatório')
          .oneOf(
            [Yup.ref('receiveCollectInfoPhone'), null],
            'Telefone diferente'
          )
      }
    ),
    receiveCollectInfoEmail: Yup.string().when('email', {
      is: (email) => !!email,
      then: Yup.string()
        .required('E-mail obrigatório')
        .matches(/^([\w.-]+)@([\w-]+)((\.(\w){2,25})+)$/, 'E-mail inválido')
    }),
    receiveCollectInfoEmailConfirmation: Yup.string().when('email', {
      is: (email) => !!email,
      then: Yup.string()
        .required('E-mail obrigatório')
        .matches(/^([\w.-]+)@([\w-]+)((\.(\w){2,25})+)$/, 'E-mail inválido')
        .oneOf([Yup.ref('receiveCollectInfoEmail'), null], 'E-mail diferente')
    })
  });

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(receiveCollectInfoSchema),
    mode: 'onBlur',
    reValidateMode: 'onBlur'
  });

  const handleChangeWhatsApp = (event) => {
    const { checked } = event.target;

    setValue('whatsapp', checked);

    setTemporaryReceiveChecked([
      checked,
      temporaryReceiveChecked[1],
      temporaryReceiveChecked[2]
    ]);
  };

  const handleChangeSMS = (event) => {
    const { checked } = event.target;

    setValue('sms', checked);

    setTemporaryReceiveChecked([
      temporaryReceiveChecked[0],
      checked,
      temporaryReceiveChecked[2]
    ]);
  };

  const handleChangeEmail = (event) => {
    const { checked } = event.target;

    setValue('email', checked);

    setTemporaryReceiveChecked([
      temporaryReceiveChecked[0],
      temporaryReceiveChecked[1],
      checked
    ]);
  };

  const handleChangeAll = (event) => {
    const { checked } = event.target;

    setTemporaryReceiveChecked([checked, checked, checked]);

    setValue('whatsapp', checked);
    setValue('sms', checked);
    setValue('email', checked);
  };

  const handleCloseModal = () => {
    closeModal();
  };

  const onSubmit = ({
    whatsapp,
    sms,
    email,
    receiveCollectInfoEmail: collectInfoEmail,
    receiveCollectInfoPhone: collectInfoPhone
  }) => {
    setReceiveCollectInfoChecked([whatsapp, sms, email]);

    if (whatsapp || sms) {
      setReceiveCollectInfoPhone(collectInfoPhone);
    } else {
      setReceiveCollectInfoPhone('');
    }

    if (email) {
      setReceiveCollectInfoEmail(collectInfoEmail);
    } else {
      setReceiveCollectInfoEmail('');
    }

    closeModal();
  };

  useEffect(() => {
    $('#receiveCollectInfoPhone').mask('(00) 0000-00009');
  }, [temporaryPhone]);

  useEffect(() => {
    $('#receiveCollectInfoPhoneConfirmation').mask('(00) 0000-00009');
  }, [temporaryPhoneConfirmation]);

  useEffect(() => {
    setValue('whatsapp', receiveCollectInfoChecked[0]);
    setValue('sms', receiveCollectInfoChecked[1]);
    setValue('email', receiveCollectInfoChecked[2]);
    setTemporaryReceiveChecked([...receiveCollectInfoChecked]);
    setValue('receiveCollectInfoPhone', receiveCollectInfoPhone);
    setTemporaryPhone(receiveCollectInfoPhone);
    setValue('receiveCollectInfoPhoneConfirmation', receiveCollectInfoPhone);
    setTemporaryPhoneConfirmation(receiveCollectInfoPhone);
    setValue('receiveCollectInfoEmail', receiveCollectInfoEmail);
    setTemporaryEmail(receiveCollectInfoEmail);
    setValue('receiveCollectInfoEmailConfirmation', receiveCollectInfoEmail);
    setTemporaryEmailConfirmation(receiveCollectInfoEmail);
  }, []);

  return (
    <Modal preventClose>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 16,
            maxHeight: '86vh',
            overflow: 'auto'
          }}
        >
          <ModalTitle>Receber Informações da Coleta por:</ModalTitle>

          <Stack
            direction={maxSM ? 'column' : 'row'}
            style={{
              width: '100%',
              gap: maxSM ? 0 : 16,
              justifyContent: 'center'
            }}
          >
            {/* <Controller
              name="whatsapp"
              control={control}
              defaultValue={temporaryReceiveChecked[0]}
              render={({ field }) => (
                <FormControlLabel
                  label="WhatsApp"
                  style={{ color: '#004e9a' }}
                  disabled
                  control={
                    // eslint-disable-next-line react/jsx-wrap-multilines
                    <Checkbox
                      data-testid="whatsappCheckboxInput"
                      {...field}
                      checked={temporaryReceiveChecked[0]}
                      onChange={(e) => {
                        handleChangeWhatsApp(e);
                      }}
                    />
                  }
                />
              )}
            /> */}

            {/* <Controller
              name="sms"
              control={control}
              defaultValue={false}
              render={({ field }) => (
                <FormControlLabel
                  label="SMS"
                  style={{ color: '#004e9a' }}
                  disabled
                  control={
                    // eslint-disable-next-line react/jsx-wrap-multilines
                    <Checkbox
                      data-testid="smsCheckboxInput"
                      {...field}
                      checked={temporaryReceiveChecked[1]}
                      onChange={(e) => {
                        field.onChange(e.target.checked);
                        handleChangeSMS(e);
                      }}
                    />
                  }
                />
              )}
            /> */}

            <Controller
              name="email"
              control={control}
              defaultValue={false}
              render={({ field }) => (
                <FormControlLabel
                  label="E-mail"
                  style={{ color: '#004e9a' }}
                  control={
                    // eslint-disable-next-line react/jsx-wrap-multilines
                    <Checkbox
                      data-testid="emailCheckboxInput"
                      {...field}
                      checked={temporaryReceiveChecked[2]}
                      onChange={(e) => {
                        field.onChange(e.target.checked);
                        handleChangeEmail(e);
                      }}
                    />
                  }
                />
              )}
            />

            {/* <FormControlLabel
              label="Todos"
              style={{ color: '#004e9a' }}
              disabled
              control={
                // eslint-disable-next-line react/jsx-wrap-multilines
                <Checkbox
                  data-testid="allCheckboxInput"
                  checked={
                    temporaryReceiveChecked[0] &&
                    temporaryReceiveChecked[1] &&
                    temporaryReceiveChecked[2]
                  }
                  onChange={handleChangeAll}
                />
              }
            /> */}
          </Stack>

          {(temporaryReceiveChecked[0] || temporaryReceiveChecked[1]) && (
            <Stack
              direction={maxSM ? 'column' : 'row'}
              spacing={2}
              style={{ width: '100%' }}
            >
              <Controller
                name="receiveCollectInfoPhone"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="DDD + Celular *"
                    id="receiveCollectInfoPhone"
                    data-testid="receiveCollectInfoPhoneInput"
                    fullWidth
                    {...field}
                    value={(field.value = temporaryPhone)}
                    onChange={(e) => {
                      setTemporaryPhone(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      if (e.target.value.length > 14) {
                        $('#receiveCollectInfoPhone').mask('(00) 00000-0009');
                      } else {
                        $('#receiveCollectInfoPhone').mask('(00) 0000-00009');
                      }

                      setTemporaryPhone(e.target.value);
                      field.onBlur(field.onChange(e.target.value));
                    }}
                    error={!!errors.receiveCollectInfoPhone}
                    helperText={errors.receiveCollectInfoPhone?.message}
                  />
                )}
              />

              <Controller
                name="receiveCollectInfoPhoneConfirmation"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Confirme o número *"
                    id="receiveCollectInfoPhoneConfirmation"
                    data-testid="receiveCollectInfoPhoneConfirmationInput"
                    fullWidth
                    {...field}
                    value={(field.value = temporaryPhoneConfirmation)}
                    onPaste={(e) => {
                      e.preventDefault();
                    }}
                    onChange={(e) => {
                      setTemporaryPhoneConfirmation(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      if (e.target.value.length > 14) {
                        $('#receiveCollectInfoPhoneConfirmation').mask(
                          '(00) 00000-0009'
                        );
                      } else {
                        $('#receiveCollectInfoPhoneConfirmation').mask(
                          '(00) 0000-00009'
                        );
                      }

                      setTemporaryPhoneConfirmation(e.target.value);
                      field.onBlur(field.onChange(e.target.value));
                    }}
                    error={!!errors.receiveCollectInfoPhoneConfirmation}
                    helperText={
                      errors.receiveCollectInfoPhoneConfirmation?.message
                    }
                  />
                )}
              />
            </Stack>
          )}

          {temporaryReceiveChecked[2] && (
            <Stack spacing={2} style={{ width: '100%' }}>
              <Controller
                name="receiveCollectInfoEmail"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="E-mail *"
                    data-testid="receiveCollectInfoEmailInput"
                    fullWidth
                    {...field}
                    value={(field.value = temporaryEmail)}
                    onChange={(e) => {
                      setTemporaryEmail(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      setTemporaryEmail(e.target.value.toLowerCase());
                      field.onBlur(
                        field.onChange(e.target.value.toLowerCase())
                      );
                    }}
                    error={!!errors.receiveCollectInfoEmail}
                    helperText={errors.receiveCollectInfoEmail?.message}
                  />
                )}
              />

              <Controller
                name="receiveCollectInfoEmailConfirmation"
                defaultValue=""
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Confirme o e-mail *"
                    data-testid="receiveCollectInfoEmailConfirmationInput"
                    fullWidth
                    {...field}
                    value={(field.value = temporaryEmailConfirmation)}
                    onPaste={(e) => {
                      e.preventDefault();
                    }}
                    onChange={(e) => {
                      setTemporaryEmailConfirmation(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      setTemporaryEmailConfirmation(
                        e.target.value.toLowerCase()
                      );
                      field.onBlur(
                        field.onChange(e.target.value.toLowerCase())
                      );
                    }}
                    error={!!errors.receiveCollectInfoEmailConfirmation}
                    helperText={
                      errors.receiveCollectInfoEmailConfirmation?.message
                    }
                  />
                )}
              />
            </Stack>
          )}

          <Stack
            direction="row"
            spacing={2}
            style={{ justifyContent: 'center', width: '100%' }}
          >
            <Button
              type="button"
              variant="contained"
              color="secondary"
              data-testid="cancelReceiveCollectInfoButton"
              onClick={handleCloseModal}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              data-testid="saveReceiveCollectInfoButton"
              variant="contained"
            >
              Salvar
            </Button>
          </Stack>
        </Box>
      </form>
    </Modal>
  );
};
